module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp1_7016.9ec4dec6.png";